import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getVisitOrder = fp.get('visit.order');

export const getAll = createSelector(getVisitOrder, fp.get('all'));

export const getIsFetching = createSelector(getVisitOrder, fp.get('fetching'));

export const getIsFetched = createSelector(getVisitOrder, fp.get('fetched'));

export const getFetchingError = createSelector(
  getVisitOrder,
  fp.get('fetchingError')
);
